// authcheck.jsx
import { useEffect } from 'react';
import api from '../../axios';
import { useAuth } from '../hooks/useAuth'; // Adjust the import path as necessary

const AuthCheck = () => {
   const { logout } = useAuth();
  useEffect(() => {
    const checkLogin = async () => {
      try {
        const res = await api.get('/user'); // Protected route
        localStorage.setItem('user', JSON.stringify(res.data))
      } catch (err) {
        console.error('Error checking login status:', err);
        if (err.response?.status === 401) {
          logout(); // Call the logout function from useAuth
        } else {
          console.error('An error occurred:', err);
        }
      }
    };

    checkLogin();
  }, []);

  return null; // No UI — this just performs a check
};

export default AuthCheck;
